export const iconFontAwesomeMovingCouch = (
	<i className="fa-solid fa-couch"></i>
);
